import isBrowser from './is-browser';

export default function getWindowHeight() {
  if (!isBrowser) {
    return 0;
  }

  const documentHeight = document.documentElement;
  const bodyHeight = document.querySelectorAll('body')[0];

  return (
    window.innerHeight || documentHeight.clientHeight || bodyHeight.clientHeight
  );
}
